// extracted by mini-css-extract-plugin
export default {"list_menu":"index_list_menu_1UI2z","morehNew":"index_morehNew_ClO3-","moreBtn":"index_moreBtn_Da3cG","more":"index_more_QSQyq"};